
// * ========================================================================
// * ages per day chart and table
// * ========================================================================

import CovidChart from './covid-chart.js';
import Tablesorter from '../table-sorter';
import moment from 'moment';
import storage from '../storage';
import { roundTo } from '../helpers';

const vaccinesPerRegion = (function(){
    let thisChart = null;
    let chartData = null;
    let dataType = null;
    let typeSelectors = null;
    const typeSelectorClass = 'input[name=age-total-vaccines-chart-data]';
    moment.locale('fi');

    function getAgeName(ageName) {
        return ageName === 'Kaikki iät' ? 'Kaikki' : ageName === '80+' ? 'yli 80 v' : ageName + ' v';
    }

    function getDoseValue(data, key, dose = 1) {
        const ageData = data.vaccines.doses[dose - 1].weeks[data.vaccines.doses[dose - 1].weeks.length - 1].ages.filter((age) => age.age === key);

        let value = ageData.length ? ageData[0].percentage : 0;
        value = value > 0 ? roundTo(value, 2) : 0;

        return value;
    }

    /**
     *
     * Show new cases per day table
     *
     * @param {Array} data - covid data
     */
    function showTable(data) {
        const tableContainer = document.querySelector('#age-total-vaccines-table');
        let table = tableContainer.querySelector('table');

        if (!table) {
            const nameValues = {
                'all_ages': -1,
            };

            let headings = '<th data-sort="number" data-default-sort-dir="up" class="sorting">Ikäryhmä</th>';
            headings += '<th data-sort="number" class="align-right">1. annos %</th>';
            headings += '<th data-sort="number" class="align-right">2. annos %</th>';

            const markup = ['<tr>'+headings+'</tr>'];
            for (const [key, age] of Object.entries(data.vaccines.ageMap)) {
                const firstDose = getDoseValue(data, key, 1);
                const secondDose = getDoseValue(data, key, 2);

                let nameValue = typeof nameValues[key] !== 'undefined' ? nameValues[key] : null;
                if (!nameValue) {
                    let nameArr = key.split('_');
                    nameValue = nameArr[nameArr.length-1];
                }

                let content = '<td data-dataset-id="'+ age.key +'" data-value="'+nameValue+'">'+getAgeName(age.name)+'</td>';
                content += '<td data-value="'+firstDose+'" class="align-right">'+firstDose+' %</td>';
                content += '<td data-value="'+secondDose+'" class="align-right">'+secondDose+' %</td>';

                markup.push('<tr>'+content+'</tr>');
            }

            tableContainer.innerHTML = '<table class="table">'+markup.join('')+'</table>';
            table = tableContainer.querySelector('table');
        }

        const tablesorter = new Tablesorter(table);

        // Set new order
        const sorter = table.querySelector('th.sorting');
        tablesorter.sortBy(sorter);
    }

    function createChartData(data, options, selected) {
        const datasets = [];

        const ageOrder = {
            all_ages: 0,
            age_0_4: 1,
            age_5_11: 2,
            age_12_17: 3,
            age_18_24: 4,
            age_20_24: 5,
            age_25_29: 6,
            age_30_34: 7,
            age_35_39: 8,
            age_40_44: 9,
            age_45_49: 10,
            age_50_54: 11,
            age_55_59: 12,
            age_60_64: 13,
            age_65_69: 14,
            age_70_74: 15,
            age_75_79: 16,
            age_80: 17
        }

        let idx = 0;
        for (const [key, age] of Object.entries(data.vaccines.ages)) {
            let value = getDoseValue(data, key, parseInt(dataType));

            datasets.push({
                label: age,
                id: key,
                backgroundColor: options.chartColors[idx],
                barPercentage: 0.95,
                categoryPercentage: 0.99,
                data: [value],
                type: 'bar',
                fill: true,
                count: value,
                order: ageOrder[key],
                selected: selected && Array.isArray(selected) ? selected.indexOf(key) !== -1 : true,
            });

            idx++;
        }

        return datasets;
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartData = data;

        typeSelectors = document.querySelectorAll(typeSelectorClass);
        getDataType();

        //showTable(chartData);

        // Initially selected
        let selectedVaccineAges = storage.getData('age-total-vaccines-chart_multiselect');
        if (!selectedVaccineAges || !Array.isArray(selectedVaccineAges)) {
            selectedVaccineAges = null;
        }

        const datasets = createChartData(chartData, window.config, selectedVaccineAges);

        thisChart = new CovidChart('age-total-vaccines-chart', {
            datasets,
            chartOptions: {
                type: 'bar',
                options: {
                    plugins: {
                        legend: {
                            display: true
                        },
                        tooltip: {
                            mode: 'nearest',
                            intersect: true,
                            enabled: true,
                            callbacks: {
                                title: function() {
                                    return '';
                                },
                                label: function(tooltipItem) {
                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + tooltipItem.formattedValue + ' %';

                                    return label;
                                }
                            },
                            itemSort: function(a, b, data) {
                                const orderA = data.datasets[a.datasetIndex].order;
                                const orderB = data.datasets[b.datasetIndex].order;

                                return orderA < orderB ? 1 : -1;
                            },
                        },
                    },
                    scales: {
                        y: {
                            ticks: {
                                // Include a % sign in the ticks
                                callback: function(value, index, values) {
                                    return value + ' %';
                                }
                            }
                        },
                        x: {
                            display: false,
                            type: 'category',
                            labels: [' ']
                        }
                    }
                }
            },
            config: window.config,
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                colorField: 'backgroundColor',
                inputName: 'age-total-vaccines-multiselect',
                selectElemId: 'age-total-vaccines-multiselect',
                colorElemId: 'age-total-vaccines-multiselect-colors',
                countElemId: 'age-total-vaccines-multiselect-count',
                selectAllElemId: 'age-total-vaccines-multiselect-select-all',
                clearAllElemId: 'age-total-vaccines-multiselect-clear-all'
            },
            responsive: ['aspectRatio', 'legend']
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default vaccinesPerRegion;
